import {isAndroid, isIOS, isMacOs, isMobile, isWindows} from "react-device-detect";
import {env} from "constants/global.vars";
import {ApiService} from "lib/http.service";

const ORDER_PATH = "/games/api/tjk/place";
const TIMEOUT_MS = 60000;

const SUBMIT_FALLBACK_ERROR =
    "Teknik hata. Kuponunuzun oynanıp oynanmadığını At Yarışı Kuponlarım sayfasından kontrol ediniz.";

interface CouponEnvelopeOptions {
    /** Kupona özgü gövde; her servis kendi `buildCouponData()` çıktısını verir. */
    coupon: any;
    save: boolean;
    usePointBalance: boolean;
    shareCoupon: boolean;
    /** Yalnız Müşterek'te true olabiliyor; diğer ikisi her zaman false gönderiyor. */
    complete?: boolean;
    /** Kuponun ekran görüntüsü (data URL); üç servis de gönderiyor, üretilemezse boş string. */
    couponImage?: any;
}

export async function postCoupon({
    coupon,
    save,
    usePointBalance,
    shareCoupon,
    complete = false,
    couponImage,
}: CouponEnvelopeOptions): Promise<any> {
    const body: any = {
        coupon,
        unit: usePointBalance ? 2 : 0,
        complete,
        save,
        tipster: shareCoupon,
        device_os: isAndroid ? "Android" : isIOS ? "iOS" : isMacOs ? "Macintosh" : isWindows ? "Windows" : "Linux",
        browser_type: "YENI-WEB",
        device_type: isMobile ? "Mobile" : "Desktop",
    };

    // Alan boş string olsa bile gönderiliyor (eski Müşterek gövdesinin davranışı); yalnız çağıran
    // hiç vermediğinde atlanıyor.
    if (couponImage !== undefined) {
        body.couponImage = couponImage;
    }

    return await new ApiService().start("post", env.betting_api + ORDER_PATH, body, true, TIMEOUT_MS);
}

/** Üç serviste de aynı olan catch gövdesi. */
export function toSubmitError(error: any) {
    return {
        status: false,
        message: error?.error?.message ?? error?.message ?? SUBMIT_FALLBACK_ERROR,
    };
}
